// English strings for the messaging, correlation and reports stream (PB-04-08, PB-09-14, PB-15-13,
// OR-11; PD-525 – PD-539). Arabic: ar-msg.ts.
export const enMsg = {
  // ------------------------------------------------------------ PB-15-13 correlation view
  'msg.corr.operations': 'Provider and adapter operations',
  'msg.corr.verifications': 'Identity verification transactions',
  'msg.corr.webhooks': 'Webhook deliveries',
  'msg.corr.inbound': 'Inbound provider events',
  'msg.corr.receipts': 'Later receipts for these records',
  'msg.corr.receiptsHint': 'Provider callbacks and reconciliation decisions recorded under another correlation reference.',
  'msg.corr.reconcile': 'Reconcile',
  'msg.corr.late': 'received late at {received}',
  'msg.corr.withheld': 'Not shown because you do not hold the read right: {names}.',
  'msg.corr.source.jobs': 'background jobs',
  'msg.corr.source.credential_operations': 'Credential operation',
  'msg.corr.source.adapter_operations': 'Adapter operation',
  'msg.corr.source.verifications': 'identity verification transactions',
  'msg.corr.source.webhooks': 'webhook deliveries',
  'msg.corr.source.access_events': 'Access event',
  'msg.corr.source.camera_reads': 'Camera read',
  'msg.corr.direction.entry': 'entry',
  'msg.corr.direction.exit': 'exit',
  'msg.corr.direction.unknown': 'direction unknown',
  // ------------------------------------------------------------ OR-11 reports (PD-536, PD-537)
  'msg.rpt.def.cards.assignments.title': 'Card assignment history',
  'msg.rpt.def.cards.assignments.description': 'Physical cards handed over, returned or recorded lost in the period, by site or day; who held which card is shown only with the detail permission.',
  'msg.rpt.def.visits.late_arrivals.title': 'Late arrivals',
  'msg.rpt.def.visits.late_arrivals.description': 'Observed arrivals measured against each planned window, in lateness bands, by site, day, host, department or visitor type. Walk-ins are not included.',
  'msg.rpt.note.cardCustody': 'Card custody is recorded separately from presence and from access credentials: a returned card can be held until every credential of its holder is confirmed inactive.',
  'msg.rpt.note.cardPeriod': 'An assignment is included when the card was out at any time in the period; by day, it counts on the day it was handed over (or the first day of the period).',
  'msg.rpt.note.lateDefinition': 'Lateness = first observed arrival for a window minus the window start. Up to 15 minutes after the start counts as on time; arrivals before the start count as on time.',
  'msg.rpt.note.lateWalkIns': 'Walk-ins have no planned start and are excluded. A window with no observed arrival is not counted here; see the no-show report.',
  'msg.rpt.metric.assignments': 'Assignments',
  'msg.rpt.metric.returned': 'Returned',
  'msg.rpt.metric.lost': 'Recorded lost',
  'msg.rpt.metric.open': 'Still out',
  'msg.rpt.metric.distinctCards': 'Distinct cards',
  'msg.rpt.metric.heldNow': 'Held for safety now',
  'msg.rpt.def.assignments': 'Card assignments whose custody overlaps the period.',
  'msg.rpt.def.returned': 'Of those, assignments ended by a recorded return.',
  'msg.rpt.def.lost': 'Of those, assignments ended by a recorded loss.',
  'msg.rpt.def.open': 'Of those, assignments not yet ended: the card is still with the visitor as far as reception knows.',
  'msg.rpt.def.heldNow': 'Cards at these sites currently held because a credential of the last holder is not yet confirmed inactive, right now.',
  'msg.rpt.metric.measured': 'Measured arrivals',
  'msg.rpt.metric.onTime': 'On time',
  'msg.rpt.metric.late': 'Late',
  'msg.rpt.metric.lateMedian': 'Median lateness (min)',
  'msg.rpt.def.measured': 'Planned windows starting in the period with an observed arrival.',
  'msg.rpt.def.onTime': 'Measured arrivals no more than 15 minutes after the window start (including early arrivals).',
  'msg.rpt.def.late': 'Measured arrivals more than 15 minutes after the window start.',
  'msg.rpt.def.lateMedian': 'Median minutes after the window start, late arrivals only; empty when none were late.',
  'msg.rpt.col.card': 'Card',
  'msg.rpt.col.assignedAt': 'Handed over',
  'msg.rpt.col.endedAt': 'Returned / lost at',
  'msg.rpt.col.assignmentState': 'Assignment',
  'msg.rpt.col.custodyNow': 'Card custody now',
  'msg.rpt.col.minutesLate': 'Minutes after start',
  'msg.rpt.col.band': 'Lateness',
  'msg.rpt.custody.available': 'Available',
  'msg.rpt.custody.assigned': 'Assigned',
  'msg.rpt.custody.returned_held': 'Returned, held for safety',
  'msg.rpt.custody.lost': 'Lost',
  'msg.rpt.custody.disabled': 'Disabled',
  'msg.rpt.custody.maintenance': 'Maintenance',
  'rpt.ui.state.open': 'Still out',
  'rpt.ui.state.returned': 'Returned',
  'rpt.ui.state.lost': 'Recorded lost',
  'rpt.ui.state.on_time': 'On time',
  'rpt.ui.state.late_15_30': '15–30 min late',
  'rpt.ui.state.late_30_60': '30–60 min late',
  'rpt.ui.state.late_60_plus': 'Over 60 min late',
  // ------------------------------------------------------------ PB-04-08 invitation required actions (PD-526)
  'msg.req.confirm_contact': 'Confirm your contact details',
  'msg.req.accept': 'Accept: {label}',
  'msg.req.sign': 'Sign: {label}',
  'msg.req.upload': 'Upload: {label}',
  'msg.req.upload_again': 'Upload again (the earlier file was not accepted): {label}',
  'msg.req.replace': 'Upload a document valid for your whole visit: {label}',
  'msg.req.beforeArrival': 'Reception can check you in only when these steps are complete.',
  // ------------------------------------------------------------ PB-09-14 delivery notices by SMS (PD-528 – PD-530)
  'msg.dlv.sms': 'Passage: {courier} has a delivery for you at {site} ({count} package(s), ref {reference}). Handover area: {point}. The desk records the handover.',
  'vpolicy.ntf.t.delivery_notice': 'Delivery waiting (recipient)',
  'dlv.reason.no_phone': 'recipient has no mobile number',
  'dlv.reason.channel_unavailable': 'no SMS provider is configured',
  'dlv.reason.channel_disabled': 'this channel is no longer enabled for delivery notices',
  'msg.v.mobilePhone': 'Enter the mobile number in international format, for example +971501234567.',
  'msg.hosts.mobilePhone': 'Mobile number (optional)',
  'msg.hosts.mobilePhoneHint': 'Used only for staff notices sent by SMS, such as a delivery waiting at the desk. Not shown in the host directory.',
} as const;
